import request from "../../utils/request";

export default {
    myTasklist: (params) => {
        return request({
            url: "/myTask/list",
            method: "post",
            data: params,
        });
    },
    myStoreFeedbackTasklist: (params) => {
        return request({
            url: "/myTask/storeFeedbackToDolist",
            method: "post",
            data: params,
        });
    },
    taskList: (params) => {
        return request({
            url: "/taskList/list",
            method: "post",
            data: params,
        });
    },
    getImg: (piId) => {
        return request({
            url: `/myTask/${piId}`,
            // url: `/myTask`,
            method: "get",
            responseType: "arraybuffer",
        });
    },
    delTask: (piId) => {
        return request({
            url: `runtime/process-instances/${piId}`,
            // url: `/myTask`,
            method: "delete",
            responseType: "arraybuffer",
        });
    },
    transfer(param) {
        return request({
            url: `taskList?action=transfer`,
            method: "put",
            data: param,
        });
    },
    commonAudit(param) {
        return request({
            url: `/openService/workflow/commonAudit`,
            method: "POST",
            data: param,
        });
    },
    getPieData() {
        return request({
            url: "/fpaPermanent/getFpaPerManentAndCampaignPriceByCategory2",
            method: "post",
        });
    },
    getBarData(params) {
        return request({
            url: "/fpaPermanent/getCountForFpaStatus",
            method: "post",
            data: params
        });
    },
    getBarData(params) {
        return request({
            url: "/fpaPermanent/getCountForFpaStatus",
            method: "post",
            data: params
        });
    },
    getQspiToDoLists(param1, param2, param3, param4, pageNum, pageSize) {
        return request({
            url: `/qspiTodo/mytask?createDateFrom=${param1}&&createDateTo=${param2}&&name=${param3}&&type=${param4}&&pageNum=${pageNum}&&pageSize=${pageSize}`,
            method: "get",
        });
    },
    getNutritionToDoLists(param1, param2, param3, param4, pageNum, pageSize) {
        return request({
            url: `/inspect/myTodoTask?createDateFrom=${param1}&&createDateTo=${param2}&&name=${param3}&&type=${param4}&&pageNum=${pageNum}&&pageSize=${pageSize}`,
            method: "get",
        });
    },
    getQspiToDoType(params) {
        return request({
            url: `/qspiTodo/type`,
            method: "get",
        });
    },
    getNutritionToDoType(params) {
        return request({
            url: `/inspect/allTodoType`,
            method: "get",
        });
    },
    closeNutritionTodo(todoId) {
        return request({
            url: `/inspect/complete-todo/${todoId}`,
            method: "get",
        });
    },
    cancelQspiToDo(type, month, ) {
        return request({
            url: `/qspiQip/todo/${type}/${month}`,
            method: "post",
            data: {}
        });
    },

};